import { render } from "./leader-widget.vue?vue&type=template&id=1667cf83"
import script from "./leader-widget.vue?vue&type=script&lang=js"
export * from "./leader-widget.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__